<template >
    <div  v-bind:style="globalStyle" >
        <div v-bind:style="paragraphStyle" >
            <div v-bind:style="paragraphTitleStyle">
                <h1>{{ $t('legalnotice.termsofservice.title') }}</h1>
            </div>
            <div> {{ $t('legalnotice.termsofservice.details.p1.text1') }}<a :href="data.legalnotice.termsofservice.portail1" target="_blank" >{{ data.legalnotice.termsofservice.portail1 }}</a>{{ $t('legalnotice.termsofservice.details.p1.text2') }}</div>
            <div> {{ $t('legalnotice.termsofservice.details.p2.text1') }} <a :href="data.legalnotice.termsofservice.portail2" target="_blank" >{{ data.legalnotice.termsofservice.portail2 }}</a>{{ $t('legalnotice.termsofservice.details.p2.text2') }}</div>
            <div v-bind:style="move"> {{ $t('legalnotice.termsofservice.details.p3') }} </div>
            <div> {{ $t('legalnotice.termsofservice.details.p4.text1') }} <br/>
            {{ $t('legalnotice.termsofservice.details.p4.text2') }}<br/>
            <a :href="'mailto:'+data.legalnotice.termsofservice.jgavaldon" target="_blank" >{{ data.legalnotice.termsofservice.jgavaldon }}</a>
            </div>
            <div> {{ $t('legalnotice.termsofservice.details.p5.text1') }} <br/>
            {{ $t('legalnotice.termsofservice.details.p5.text2') }}<br/>
            <a :href="'mailto:'+data.legalnotice.termsofservice.dpo" target="_blank" >{{ data.legalnotice.termsofservice.dpo }}</a>
            </div>
        </div>

        <div v-bind:style="paragraphStyle" >
            <div v-bind:style="paragraphTitleStyle">
                <h1>{{ $t('legalnotice.generalinformations.title') }}</h1>
            </div>
            <div> {{ $t('legalnotice.generalinformations.details.p1') }}</div>
            <div> {{ $t('legalnotice.generalinformations.details.p2') }}</div>
            <div> {{ $t('legalnotice.generalinformations.details.p3') }}</div>
            <div> {{ $t('legalnotice.generalinformations.details.p4') }}</div>
            <div> <u>{{ $t('legalnotice.generalinformations.details.p5.text1') }}</u> {{ $t('legalnotice.generalinformations.details.p5.text2') }}</div>
            <div> {{ $t('legalnotice.generalinformations.details.p6') }}</div>
        </div>

        <div v-bind:style="paragraphStyle" >
            <div v-bind:style="paragraphTitleStyle">
                <h1>{{ $t('legalnotice.copyright.title') }}</h1>
            </div>
            <div> {{ $t('legalnotice.copyright.details.p1') }}</div>
            <div> {{ $t('legalnotice.copyright.details.p2') }}</div>
            <div> {{ $t('legalnotice.copyright.details.p3') }}</div>
            <div> {{ $t('legalnotice.copyright.details.p4') }}</div>
        </div>

        <div v-bind:style="paragraphStyle" >
            <div v-bind:style="paragraphTitleStyle">
                <h1>{{ $t('legalnotice.trademarkrights.title') }}</h1>
            </div>
            <div> {{ $t('legalnotice.trademarkrights.details.p1') }}</div>
        </div>

        <div v-bind:style="paragraphStyle" >
            <div v-bind:style="paragraphTitleStyle">
                <h1>{{ $t('legalnotice.dataretention.title') }}</h1>
            </div>
            <div> {{ $t('legalnotice.dataretention.details.p1') }}</div>
        </div>

        <div v-bind:style="paragraphStyle" >
            <div v-bind:style="paragraphTitleStyle">
                <h1>{{ $t('legalnotice.cookies.title') }}</h1>
            </div>
            <div> {{ $t('legalnotice.cookies.details.p1') }}</div>
            <div> {{ $t('legalnotice.cookies.details.p2') }}</div>
            <div> {{ $t('legalnotice.cookies.details.p3') }}</div>
        </div>

        <div v-bind:style="paragraphStyle" >
            <div v-bind:style="paragraphTitleStyle">
                <h1>{{ $t('legalnotice.hypertextlinks.title') }}</h1>
            </div>
            <div> {{ $t('legalnotice.hypertextlinks.details.p1.text1') }} <a :href="data.legalnotice.hypertextlinks.portail" target="_blank" >{{ data.legalnotice.hypertextlinks.portail }}</a> {{ $t('legalnotice.hypertextlinks.details.p1.text2') }} <a :href="'mailto:' + data.legalnotice.hypertextlinks.contact" target="_blank" >{{ data.legalnotice.hypertextlinks.contact }}</a> </div>
            <div> {{ $t('legalnotice.hypertextlinks.details.p2.text1') }} <a :href="data.legalnotice.hypertextlinks.astekgroup" target="_blank" >{{ data.legalnotice.hypertextlinks.astekgroup }}</a> {{ $t('legalnotice.hypertextlinks.details.p2.text2') }}  </div>
        </div>

        <div v-bind:style="paragraphStyle" >
            <div v-bind:style="paragraphTitleStyle">
                <h1>{{ $t('legalnotice.limitationofliability.title') }}</h1>
            </div>
            <div> {{ $t('legalnotice.limitationofliability.details.p1') }}</div>
            <div> {{ $t('legalnotice.limitationofliability.details.p2') }}</div>
            <div> {{ $t('legalnotice.limitationofliability.details.p3') }}</div>
        </div>

        <div v-bind:style="paragraphStyle" >
            <div v-bind:style="paragraphTitleStyle">
                <h1>{{ $t('legalnotice.applicableright.title') }}</h1>
            </div>
            <div> {{ $t('legalnotice.applicableright.details.p1') }}</div>
        </div>

         <div v-bind:style="paragraphStyle" >
            <div v-bind:style="paragraphTitleStyle">
                <h1>{{ $t('legalnotice.updateofgeneralconditions.title') }}</h1>
            </div>
            <div> {{ $t('legalnotice.updateofgeneralconditions.details.p1') }}</div>
        </div>

    </div>
</template>
<script>
import Vue from "vue";
import data from '../../datas';
export default {
  name: 'LegalNotice',
  data() {
    return {
        data,
        globalStyle: {
            fontSize: '0.8rem',
            marginLeft:'10px',
            marginRight:'10px',
            textAlign:'justify',
            marginBottom:'100px'
        },
        paragraphStyle:{
            marginTop:'50px'
        },
        paragraphTitleStyle:{
            marginBottom:'20px',
            textAlign:'center'
        },
        move:{
            marginTop:'15px'
        }


    }
  }
};
</script>